/**
 * Enhanced movement processing with time-based interpolation
 * Smoother gameplay with better frame rate independence
 */

import { processMovement } from "./movement";
import { updateCamera } from "./cameraControl";

// Fixed delta time for stable physics calculation
const FIXED_DELTA = 1.0; // Standard multiplier for predictable movement

/**
 * Process game updates with simplified timing
 * This provides stable movement without overcomplicating timing
 */
export function processGameUpdates(): void {
  // Process movement with stable deltaTime
  // This prevents varying movement speeds due to frame rate differences
  processMovement(FIXED_DELTA);

  // Update camera separately for smoother visuals
  updateCamera();
}
